import { Box, Link, Stack, Typography } from '@mui/material';
import { Img } from 'react-image';

import APPLOGO from 'components/Logo/appmachine-logo.jpeg';

const DrawerFooter = () => (
  <Box
    sx={{
      mt: 'auto',
      mx: 2,
      mb: 2,
      px: 2,
      py: 2,
      border: (theme) => `1px solid ${theme.palette.divider}`,
      borderRadius: 2,
      bgcolor: 'background.paper'
    }}
  >
    <Stack spacing={1.25} alignItems="center">
      <Img src={APPLOGO} width="85px" />
      <Typography variant="subtitle2" color="secondary" align="center" component="div">
        &copy; Powered By{' '}
        <Link
          href="https://appmachine.in"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          color="inherit"
          sx={{ fontWeight: 500 }}
        >
          App Machine India
        </Link>
      </Typography>
    </Stack>
  </Box>
);

export default DrawerFooter;
